import React from 'react';
import { Typography, Box, useTheme } from '@mui/material';

interface IProps {
  children?: React.ReactNode;
  //eslint-disable-next-line
  Icon?: React.ComponentType<any>;
  minHeight?: string;
}

export type ExtendedErrorDisplayProps = Omit<IProps, 'children' | 'Icon'>;

const ErrorDisplay = ({ children, Icon, minHeight = '400px' }: IProps) => {
  const theme = useTheme();
  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      minHeight={minHeight}
    >
      {Icon ? (
        <Icon sx={{ color: theme.palette.grey[500], fontSize: '200px' }} />
      ) : null}
      {children ? (
        <Typography sx={{ color: theme.palette.grey[500] }} variant='h5'>
          {children}
        </Typography>
      ) : null}
    </Box>
  );
};

export default ErrorDisplay;
